
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bookmarks/articles",
      function () {
        return require("private-next-pages/bookmarks/articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bookmarks/articles"])
      });
    }
  